/**
 * Resolve which process-wizard step to open on.
 * Priority: payslips (if published) → finalise (if month finalised) →
 * session memory → first incomplete → last step.
 */
export function resolveProcessWizardLanding({
  steps = [],
  storageKey = "",
  monthFinalised = false,
  payslipsPublished = false,
}) {
  const list = Array.isArray(steps) ? steps : [];
  const keys = list.map((s) => s.key).filter(Boolean);
  const has = (k) => keys.includes(k);

  let stored = "";
  if (storageKey) {
    try {
      stored = String(sessionStorage.getItem(storageKey) || "");
    } catch {
      stored = "";
    }
  }

  if (payslipsPublished && has("payslips")) return "payslips";

  if (monthFinalised) {
    if (stored && (stored === "finalise" || stored === "payslips") && has(stored)) {
      return stored;
    }
    if (has("finalise")) return "finalise";
  }

  if (stored && has(stored)) return stored;

  const firstPending = list.find(
    (s) => !["passed", "acknowledged"].includes(String(s.status || ""))
  );
  if (firstPending?.key) return firstPending.key;

  if (has("payslips")) return "payslips";
  if (has("finalise")) return "finalise";
  return keys[0] || null;
}

export function persistProcessWizardLanding(storageKey, stepKey) {
  if (!storageKey || !stepKey) return;
  try {
    sessionStorage.setItem(storageKey, String(stepKey));
  } catch {
    /* ignore quota / private mode */
  }
}
